export default __webpack_public_path__ + "static/media/af-emirate.bb2f44cd.svg";